import { type TFunction } from 'i18next'
import { type Steps } from '#types/form/wizard.ts'

interface GetStepsContextParams {
	currentQuestionId: string
	currentQuestionTreeId: string
	editableParents: string[]
	questionTree: any
	answeredQuestionsStack: any
}

interface StepConfig {
	getSteps: Function
	includeContext: boolean
	needsController?: boolean
}

interface GetCombinedStepsParams {
	steps: StepConfig[]
	t: TFunction
	contextParams?: GetStepsContextParams
	needsController?: boolean
}

export function getCombinedSteps({
	steps,
	t,
	contextParams,
}: GetCombinedStepsParams) {
	let combinedSteps: Steps<any>[] = []

	steps.forEach(({ getSteps, includeContext, needsController }) => {
		const stepsToAdd =
			includeContext && contextParams
				? getSteps({ ...contextParams, needsController, t })
				: getSteps({ t })
		combinedSteps = [...combinedSteps, ...stepsToAdd] as any
	})

	return () => combinedSteps
}
